import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { isExamCapableDevice, onDeviceCapabilityChange } from '../utils/deviceSupport'
import './DesktopOnlyGate.css'

/**
 * Renders `children` only on an exam-capable device.
 *
 * This wraps the exam ROUTE rather than living inside the exam page on purpose.
 * TestTaking calls startTest() from a mount effect, which POSTs
 * /api/tests/<id>/start and creates a TestAttempt with a running timer. An
 * early return inside the page would not help: hooks still run. Gating at the
 * route means React never mounts the page at all, so no attempt is ever created
 * on a phone.
 */
const DesktopOnlyGate = ({ children }) => {
  const history = useHistory()
  // Lazy initialiser, not an effect: an effect would let one frame of the exam
  // render (and its mount effect fire) before the gate swapped in.
  const [capable, setCapable] = useState(() => isExamCapableDevice())

  useEffect(() => onDeviceCapabilityChange(setCapable), [])

  if (capable) return children

  return (
    <div className="desktop-gate">
      <div className="desktop-gate-card">
        <img
          src="/rts-logo.png"
          alt="Rapid Testing Service"
          className="desktop-gate-logo"
        />
        <h1 className="desktop-gate-title">Please use a desktop or laptop</h1>
        <p className="desktop-gate-text">
          This exam is monitored by our AI proctoring system, which needs a
          desktop or laptop computer with a webcam. It cannot run reliably on a
          phone or tablet.
        </p>
        <p className="desktop-gate-text desktop-gate-reassure">
          Nothing has been started and no attempt has been used. You can open
          this exam on a computer whenever you are ready.
        </p>
        <button
          type="button"
          className="desktop-gate-button"
          onClick={() => history.push('/available-tests')}
        >
          Back to available tests
        </button>
      </div>
    </div>
  )
}

DesktopOnlyGate.propTypes = {
  children: PropTypes.node,
}

export default DesktopOnlyGate
